import React, { useEffect, useState, useRef } from 'react';
import { CheckCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Carlos M.',
  initial: 'C',
  location: 'México',
  time: 'hace 2 min'
}, {
  name: 'Lucía F.',
  initial: 'L',
  location: 'Argentina',
  time: 'hace 5 min'
}, {
  name: 'Diego R.',
  initial: 'D',
  location: 'Colombia',
  time: 'hace 8 min'
}, {
  name: 'Sofía P.',
  initial: 'S',
  location: 'España',
  time: 'hace 12 min'
}, {
  name: 'Andrés V.',
  initial: 'A',
  location: 'Chile',
  time: 'hace 15 min'
}, {
  name: 'Mariana G.',
  initial: 'M',
  location: 'Perú',
  time: 'hace 18 min'
}, {
  name: 'Rafael T.',
  initial: 'R',
  location: 'Venezuela',
  time: 'hace 21 min'
}, {
  name: 'Camila B.',
  initial: 'C',
  location: 'Uruguay',
  time: 'hace 3 min'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showNotification = () => {
      setBuyerIndex(prev => (prev + 1) % buyers.length);
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
      hideTimeout = setTimeout(() => setIsVisible(false), 5000);
      intervalRef.current = setInterval(showNotification, 30000);
    }, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  const buyer = buyers[buyerIndex];
  return <AnimatePresence data-id="element-351">
      {isVisible && <motion.div initial={{
      x: -320,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -320,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="fixed bottom-[90px] left-4 z-[200] max-w-[320px] max-sm:left-2.5 max-sm:max-w-[calc(100vw-20px)] max-sm:bottom-[80px]" data-id="element-352">
          <div className="relative bg-[#141414] border border-[rgba(232,184,75,.45)] rounded-xl p-4 pr-9 flex items-start gap-3.5 shadow-[0_8px_40px_rgba(0,0,0,.6),0_0_20px_rgba(201,151,43,.15)]" data-id="element-353">
            {/* Glow accent top */}
            <div className="absolute top-0 left-0 right-0 h-[2px] rounded-t-xl bg-[linear-gradient(90deg,transparent,var(--dorado-claro),var(--verde),transparent)]" data-id="element-354" />

            {/* Avatar */}
            <div className="relative shrink-0" data-id="element-355">
              <div className="w-[44px] h-[44px] rounded-full bg-[linear-gradient(135deg,#E8B84B,#C9972B)] flex items-center justify-center text-negro font-black text-lg shadow-[0_0_12px_rgba(201,151,43,.4)]" data-id="element-356">
                {buyer.initial}
              </div>
              <div className="absolute -bottom-0.5 -right-0.5 w-[18px] h-[18px] bg-verde rounded-full flex items-center justify-center border-2 border-[#141414]" data-id="element-357">
                <CheckCircle className="w-2.5 h-2.5 text-white" data-id="element-358" />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-359">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-360">
                <span className="font-bold text-[.88rem] text-blanco truncate" data-id="element-361">
                  {buyer.name}
                </span>
                <span className="inline-flex items-center gap-1 bg-[rgba(29,185,84,.2)] text-verde text-[9px] font-bold uppercase tracking-[.08em] px-1.5 py-0.5 rounded-sm whitespace-nowrap" data-id="element-362">
                  ✓ Verificado
                </span>
              </div>
              <div className="text-[.8rem] text-crema-oscuro leading-snug" data-id="element-363">
                acaba de adquirir{' '}
                <span className="font-semibold text-dorado-claro" data-id="element-364">
                  Código Oscuro
                </span>
              </div>
              <div className="text-[.72rem] text-dorado mt-1 flex items-center gap-1.5" data-id="element-365">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-verde animate-pulse" data-id="element-366" />
                {buyer.time} · {buyer.location}
              </div>
            </div>

            {/* Close */}
            <button onClick={() => setIsVisible(false)} className="absolute top-2.5 right-2.5 text-gris-texto hover:text-blanco transition-colors bg-transparent border-none cursor-pointer p-0.5" data-id="element-367">
              <X className="w-3.5 h-3.5" data-id="element-368" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}